import { MouseClickRightSvg } from "@lhd/assets";
import { IData } from "../hook";

export const MONTHLY = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const useColumns = (size?: any) => {
  return [
    {
      columnId: "index",
      label: "No.",
      type: "text",
      width: 40,
      editTable: true,
      icon: <></>,
    },
    {
      columnId: "year_cycle",
      label: "年度",
      type: "text",
      width: 100,
      icon: <></>,
    },
    {
      columnId: "month",
      label: "月度",
      type: "text",
      width: 100,
      icon: <></>,
    },
    {
      columnId: "worker_id",
      label: "社員",
      type: "text",
      width: 215,
      icon: <MouseClickRightSvg size={size} />,
    },
    {
      columnId: "amount",
      label: "控除額",
      type: "numberCurrency",
      width: 150,
      icon: <></>,
    },
    {
      columnId: "memo",
      label: "M E Ｍ Ｏ",
      type: "text",
      width: 400,
      icon: <></>,
    },
  ];
};

export const handleData = (data: IData[]) => {
  const lengthData = data?.length;
  const lastIndex = data?.[lengthData - 1]?.id
    ? data?.[lengthData - 1]?.id + 1
    : lengthData;

  return [
    ...data,
    ...Array.from(
      Array(data.length > 1000 ? 0 : 1000 - data.length).keys(),
    ).map((_, index) => ({
      id: index + lastIndex,
      month: "",
      year_cycle: "",
      worker_id: "",
      amount: "",
      memo: "",
      isCreate: true,
      index: "",
    })),
  ];
};

export const emptyData = {
  month: "",
  year_cycle: "",
  worker_id: "",
  amount: "",
  memo: "",
  isCreate: true,
};

export const checkInvalid = (
  data: IData,
  fields?: string[],
  countFieldValidate?: number,
) => {
  let result = false;
  let haveData = false;
  let countFieldInvalid = 0;
  if (fields) {
    fields.forEach((fieldItem) => {
      if (!data?.[fieldItem as keyof IData]) {
        result = true;
        countFieldInvalid = countFieldInvalid + 1;
      } else {
        haveData = true;
      }
    });
  } else {
    Object.keys(data).forEach((keyItem: string) => {
      if (!data?.[keyItem as keyof IData]) {
        result = true;
      } else {
        haveData = true;
      }
    });
  }
  return {
    invalid:
      countFieldValidate === undefined
        ? result
        : result && fields && countFieldInvalid === countFieldValidate,
    haveData,
  };
};

export const deduction_special_fields_convert_attr = ["worker_id"];
